import { Box, Text } from '@cdl/heartbeat-react';

interface Props {
  label: string;
  value: number | string;
}

export const PatientInfoCard: React.FC<Props> = ({ label, value }) => {
  return (
    <Box>
      <Text
        textStyle='category-subtitle'
        fontWeight='semibold'
        color='neutral.400'
        mb='xs'
      >
        {label}
      </Text>
      <Text textStyle='category-subtitle' fontWeight='semibold' fontSize='xs'>
        {value}
      </Text>
    </Box>
  );
};
